<div class="scw-typography-showcase">
  <mat-card class="section-card" appearance="outlined">
    <mat-card-header>
      <mat-card-title>Widget Classes</mat-card-title>
    </mat-card-header>
    <mat-divider></mat-divider>
    <mat-card-content>
      <div class="typo-row">
        <div class="meta-col">
          <span class="class-badge">.text-display-large</span>
          <p class="usage">Used for large metrics and hero numbers.</p>
        </div>
        <div class="preview-col text-display-large">1,234,567</div>
      </div>
      <mat-divider></mat-divider>

      <div class="typo-row">
        <div class="meta-col">
          <span class="class-badge">.text-display-medium</span>
          <p class="usage">
            Medium-sized metrics and prominent data. Generally used as the standard size for dashboard widgets.
          </p>
        </div>
        <div class="preview-col text-display-medium">89.4%</div>
      </div>
      <mat-divider></mat-divider>

      <div class="typo-row">
        <div class="meta-col">
          <span class="class-badge">.text-display-small</span>
          <p class="usage">Small displays and sub-metrics.</p>
        </div>
        <div class="preview-col text-display-small">$45,000</div>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card class="section-card" appearance="outlined">
    <mat-card-header>
      <mat-card-title>Title Classes</mat-card-title>
    </mat-card-header>
    <mat-divider></mat-divider>
    <mat-card-content>
      <div class="typo-row">
        <div class="meta-col">
          <span class="class-badge">.text-title-large</span>
          <p class="usage">Large card or main section titles.</p>
        </div>
        <div class="preview-col text-title-large">User Statistics</div>
      </div>
      <mat-divider></mat-divider>

      <div class="typo-row">
        <div class="meta-col">
          <span class="class-badge">.text-title-medium</span>
          <p class="usage">Standard card and modal titles.</p>
        </div>
        <div class="preview-col text-title-medium">Recent Actions</div>
      </div>
      <mat-divider></mat-divider>

      <div class="typo-row">
        <div class="meta-col">
          <span class="class-badge">.text-title-small</span>
          <p class="usage">Subsection and small block titles.</p>
        </div>
        <div class="preview-col text-title-small">Account Details</div>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card class="section-card" appearance="outlined">
    <mat-card-header>
      <mat-card-title>Body Classes (Data and Text)</mat-card-title>
    </mat-card-header>
    <mat-divider></mat-divider>
    <mat-card-content>
      <div class="typo-row">
        <div class="meta-col">
          <span class="class-badge">.text-body-xlarge</span>
          <p class="usage">Extra large highlighted table data.</p>
        </div>
        <div class="preview-col text-body-xlarge">Pending Action</div>
      </div>
      <mat-divider></mat-divider>

      <div class="typo-row">
        <div class="meta-col">
          <span class="class-badge">.text-body-large</span>
          <p class="usage">Large list items or highlighted text.</p>
        </div>
        <div class="preview-col text-body-large">John Doe</div>
      </div>
      <mat-divider></mat-divider>

      <div class="typo-row">
        <div class="meta-col">
          <span class="class-badge">.text-body-medium</span>
          <p class="usage">Standard table cells and general reading text.</p>
        </div>
        <div class="preview-col text-body-medium">This transaction has been automatically approved by the system.</div>
      </div>
      <mat-divider></mat-divider>

      <div class="typo-row">
        <div class="meta-col">
          <span class="class-badge">.text-body-small</span>
          <p class="usage">Helper text, small notes, and descriptions.</p>
        </div>
        <div class="preview-col text-body-small">Last updated: 2 hours ago</div>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card class="section-card" appearance="outlined">
    <mat-card-header>
      <mat-card-title>Label Classes (Table Headers)</mat-card-title>
    </mat-card-header>
    <mat-divider></mat-divider>
    <mat-card-content>
      <div class="typo-row">
        <div class="meta-col">
          <span class="class-badge">.text-label-large</span>
          <p class="usage">Large table headers, status labels.</p>
        </div>
        <div class="preview-col text-label-large">Order Number</div>
      </div>
      <mat-divider></mat-divider>

      <div class="typo-row">
        <div class="meta-col">
          <span class="class-badge">.text-label-medium</span>
          <p class="usage">Standard table column headers (metadata).</p>
        </div>
        <div class="preview-col text-label-medium">Registration Date</div>
      </div>
      <mat-divider></mat-divider>

      <div class="typo-row">
        <div class="meta-col">
          <span class="class-badge">.text-label-small</span>
          <p class="usage">Small labels and badge text.</p>
        </div>
        <div class="preview-col text-label-small">Tax Included</div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
